import { useEffect, useRef } from "react";
import { useActivityScrollContext } from "../context/activity-scroll-context";
import { useActivityContext } from "./activity-context.hook";
import { isNearBottom } from "../utils/scroll.utils";

export const useScrollAfterAction = (mutation: any) => {
  const { scrollToBottom, containerEl } = useActivityScrollContext();
  const { isFetching, isFetchingNextPage, forceRefetch } = useActivityContext();
  const shouldScrollRef = useRef(false);
  const isWaitingForDataRef = useRef(false);
  const wasNearBottomRef = useRef(false);

  // When mutation succeeds, immediately trigger refetch (just like scrollToBottomWithRefresh)
  useEffect(() => {
    if (mutation.isSuccess && !shouldScrollRef.current) {
      // Check if user is near bottom before we start the action
      wasNearBottomRef.current = isNearBottom(containerEl, 100);

      shouldScrollRef.current = true;
      isWaitingForDataRef.current = true;

      // Small delay to ensure cache clearing in onSuccess has completed
      const timeoutId = setTimeout(() => {
        forceRefetch();
      }, 50);

      return () => clearTimeout(timeoutId);
    }
  }, [mutation.isSuccess, forceRefetch, containerEl]);

  // After refetch completes, scroll to bottom only if user was near bottom when comment was added
  useEffect(() => {
    if (
      shouldScrollRef.current &&
      isWaitingForDataRef.current &&
      !isFetching &&
      !isFetchingNextPage
    ) {
      // Data has loaded, now scroll to bottom only if user was near bottom
      let rafId: number;
      let timeoutId: NodeJS.Timeout;

      rafId = requestAnimationFrame(() => {
        timeoutId = setTimeout(() => {
          // // Only scroll if user was near bottom when they added the comment
          if (wasNearBottomRef.current) {
            scrollToBottom();
            
          }
          shouldScrollRef.current = false;
          isWaitingForDataRef.current = false;
          wasNearBottomRef.current = false;
        }, 100);
      });

      return () => {
        if (rafId) cancelAnimationFrame(rafId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    }
  }, [isFetching, isFetchingNextPage, scrollToBottom]);
};
